const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { resultSelected } = require('actions/glossary');
const GlossarySearchResult = require('./GlossarySearchResult');
require('./GlossaryResultsList.scss');


const GlossaryResultsList = ({ results, selectedResult, selectResult }) => (
    <div
        className="container--results"
        style={{ opacity: selectedResult ? 0.5 : 1 }}
    >
        <div className="no--scrollbar">
            {
                results.map(result => (
                    <GlossarySearchResult
                        key={result}
                        onClick={() => selectResult(result)}
                        result={result}
                    />
                ))
            }
        </div>
    </div>
);


GlossaryResultsList.propTypes = {
    results: PropTypes.array.isRequired,
    selectedResult: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    selectResult: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    results: state.glossary.results,
    selectedResult: state.glossary.selectedResult,
});

const mapDispatchToProps = dispatch => ({
    selectResult: result => dispatch(resultSelected({ result })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(GlossaryResultsList);
